import { IAAResponse } from 'models/IAA'
import { api } from '../api'
import { StudioCampaignPagesResponse, StudioCampaignResponse } from 'models/StudioCampaign'

const campaignsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCampaign: builder.query<StudioCampaignResponse, string>({
      query: (campaignId: string) => `/studio-campaigns/${campaignId}?published=1`,
    }),
    getPages: builder.query<StudioCampaignPagesResponse, string>({
      query: (campaignId: string) => `/studio-campaigns/${campaignId}/pages?published=1`,
    }),
    getIAA: builder.query<
      IAAResponse,
      { campaignId: string; heapId: string | null; sessionId?: string | null }
    >({
      query: ({ campaignId, heapId, sessionId }) => {
        const queryParams = new URLSearchParams()

        if (heapId) {
          queryParams.append('heapId', heapId)
        }

        if (sessionId) {
          queryParams.append('sessionId', sessionId)
        }

        return `/campaigns/${campaignId}/intelligent-ask?${queryParams.toString()}`
      },
    }),
  }),
})

export const {
  useGetCampaignQuery,
  useGetPagesQuery,
  useGetIAAQuery,
  endpoints: { getCampaign, getPages, getIAA },
} = campaignsApi

export default campaignsApi
